module.exports = __webpack_public_path__ + "img/spain-flag.9c418fb4.svg";